import { FirebaseContext } from '@/context';
import { initializeApp } from 'firebase/app';
// import localFirebaseConfig from '@/../.firebase-config.json';
// import { SSR, env } from '@/env';
import type { ReactNode } from 'react';

interface FirebaseProviderProps {
  firebaseConfig: Record<string, unknown>;
  children: ReactNode;
}

// const firebaseConfig = loadFirebaseConfig();

export const FirebaseProvider = ({
  firebaseConfig,
  children,
}: FirebaseProviderProps) => {
  // if (env === 'development' && !SSR) {
  //   firebaseConfig.authDomain = window.location.host;
  //   console.log(firebaseConfig);
  // }
  if (
    firebaseConfig &&
    typeof window !== 'undefined' &&
    (window.location.hostname !== 'localhost' ||
      window.location.protocol !== 'http:')
  ) {
    firebaseConfig.authDomain = window.location.host;
  }

  // // @ts-expect-error in CI, FirebaseConfig does not include an apiKey
  const apiKey: string | undefined = firebaseConfig?.apiKey as
    | string
    | undefined;

  const fb = apiKey ? initializeApp(firebaseConfig) : undefined;

  if (!fb) {
    console.error(
      'Firebase not initialized. Check your Firebase configuration.',
    );

    // Don't inject the provider if Firebase is not initialized
    return <>{children}</>;
  }

  return (
    <FirebaseContext.Provider value={{ app: fb, firebaseConfig }}>
      {children}
    </FirebaseContext.Provider>
  );
};
